var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledArrow = function SvgCircledArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m17.13 14.082-3.586 3.563V8.043a.542.542 0 0 0-.928-.384.54.54 0 0 0-.16.384v9.602L8.87 14.082a.544.544 0 0 0-.761.76l4.51 4.503a.544.544 0 0 0 .761 0l4.511-4.503a.541.541 0 0 0-.396-.867.54.54 0 0 0-.365.107"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 12.5,
    stroke: "#000"
  })));
};
export default SvgCircledArrow;